import { configureStore } from "@reduxjs/toolkit";
import PageSlice from "./../Slice/PageSlice.js" ; 
import UserSlice from "./../Slice/UserSlice.js" ; 
import AuthSlice from "./../Slice/Auth/AuthSlice.js" ;
import GroupSlice from "./../Slice/Groups/GroupSlice.js";
import ExtractPagePostsWithIdSlice from "../Slice/Extract/ExtractPageWithIdSlice.js" ;
import ExtractPageSearchSlice from "../Slice/Extract/ExtractPageSearchSlice.js" ;
import ExtractDataFromDBSlice from "../Slice/Extract/ExtractDataFromDBSlice.js"
import MessagesSlice from "../Slice/Messages/MessageSlice.js" ;
import CollectSlice from "../Slice/GroupData/CollectSlice.js" ; 
import AdminSlice from "../Slice/Admin/AdminSlice.js" ; 
import SpecificGroupSlice from "../Slice/SpecificGroup/SpecificGroupSlice.js" ; 
import SpecificPostSlice from "../Slice/SpecificPost/SpecificPostSlice.js" ; 
import extractGroupMemberSlice from "../Slice/Extract/ExtractGroupMemberSlice.js" ;
import MessengerSlice from "../Slice/Messengers/MessengersSlice.js" ;


export const store = configureStore({
    reducer : {
        PageSlice , 
        UserSlice , 
        AuthSlice , 
        GroupSlice , 
        ExtractPagePostsWithIdSlice , 
        ExtractPageSearchSlice , 
        ExtractDataFromDBSlice , 
        MessagesSlice , 
        CollectSlice ,
        AdminSlice , 
        SpecificGroupSlice , 
        SpecificPostSlice , 
        extractGroupMemberSlice , 
        MessengerSlice
    }
})